import {
  GET_LIST_TONGQUATCUAHANG,
  GET_LIST_TONGQUATCUAHANG_SUCCESS,
  GET_LIST_TONGQUATCUAHANG_FAILURE,
} from "actions/TongQuatCuaHang/actionTypes";

const initialState = {
  getListTongQuatCuaHangLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListTongQuatCuaHang = (state, action) => ({
  ...state,
  getListTongQuatCuaHangLoading: true,
});

const getListTongQuatCuaHangSuccess = (state, action) => {
  return {
    ...state,
    getListTongQuatCuaHangLoading: false,
    objList: action.payload,
  };
};

const getListTongQuatCuaHangFailed = (state, action) => ({
  ...state,
  getListTongQuatCuaHangLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TONGQUATCUAHANG:
      return getListTongQuatCuaHang(state, action);
    case GET_LIST_TONGQUATCUAHANG_SUCCESS:
      return getListTongQuatCuaHangSuccess(state, action);
    case GET_LIST_TONGQUATCUAHANG_FAILURE:
      return getListTongQuatCuaHangFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
